<template>
    <div class="row">
			<div class="col-md-8" style='text-align:center;'>
				<h1>
					Compare <strong>{{ myHospital.name }}</strong> To:
				</h1>
				<hr />
				<br/>
				<div class="row">
					<div class="col-md-6 col-md-offset-3">
						<button class="btn btn-default btn-lg" value="state" name="state" @click="nextPage">My State</button>
						<button class="btn btn-default btn-lg" value="peergroup" name="peergroup" @click="nextPage">My Peer Group</button>
						<button class="btn btn-default btn-lg" type="button" onclick="addGroup();$('#custom1').removeClass('hide');">Custom</button>
						<br />
						<br />
						<div class="row">
							<div class="col-md-12" id="querygroup">
								<querygroup 
						            index="1"
						            :states="arrstates"
						            :user="store.user"
						            :indicator="store.indicator"
						            :years="store.years"
						            :chart-type="chartType"
						            :default-year="store.defaultYear"
						            ref="group1"
						            ></querygroup>
						         <button class="btn btn-default btn-sm hide"  id=
						        "custom1" @click="nextPage" value="custom">Draw Graph</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4" id="myhosp">
				<hospital
	            :user="store.user"
	            :years="store.years"
	            :default-year="store.defaultYear"
	            :showyear="false"
	            ref="myhosp"
				></hospital>
			</div>	
		</div>
</template>

<script type="module">

</script>

<script setup>

import { ref, toRaw } from "vue"; 
import { storeToRefs } from 'pinia'
import { useVisualizationsStore } from '../../stores/vis_store'
import hospital from './hospital.vue'
import querygroup from './querygroup.vue'
import { onMounted } from 'vue';


const { fetchHospitals, fetchStates, loadPage} = useVisualizationsStore()
const { arrhospitals , arrstates, chartType, currentPage, loading, years} = storeToRefs(useVisualizationsStore())
var store = useVisualizationsStore()
//const myHospital = toRaw(store.user.hospitals.at(-1));
// console.log( store.defaultYear )
// console.log(toRaw(store.user.hospitals))
var foundHospital = toRaw( store.user.hospitals.find(h => h.year == store.defaultYear) )
if (foundHospital == null) {
	console.log("getting latest")
	foundHospital = toRaw(store.user.hospitals.at(-1))
}
const myHospital = foundHospital;
console.log(myHospital)
if (toRaw(chartType).value == 'fdi') {
	let data = []; 
		//console.log(myHospital);
		data.push({ 'myhospital': myHospital.cahid, 
			'myhospitalname': myHospital.name,
			'myhosp_year': myHospital.year,
			'state': "state",
			'group_year': myHospital.year,
			'group_name': 'My State',
			'group_geography':"state",
			"group_geography_state":myHospital.cahstate,
			"group_geography_region": 0,
			"group_geography_national":0,
			"group_geography_national":0,
			'group_netpatrev':0,
			'group_ruralclinic':0,
			'group_longtermcare':0,
			'group_govtowned':0,
			'group_system':0,
			'group_cahid':"",
			'group_hidden': false,
			'index': 1
		});
		
		store.groups = data;
		store.loadPage('visualization');
}

fetchHospitals();
fetchStates();
const groups = [];
const group1 = ref(null); 

const myhosp = ref(null);

groups.push(group1);





var numFound = 0;


onMounted(() => {
    
        
});



const handleGroupData = () => { 
    let data = []; 
    let myhosp_year = myhosp.value.myhosp_year;
    
    groups.forEach(function(group) {
      let d = group.value.gatherData();
      if (d.group_hidden == false) {
        if (d.group_cahid != "") {
            data.push({ 'group_cahid': d.group_cahid, 'hosp_year': myhosp_year })
        } else {
        	d.hosp_year =  myhosp_year;
            data.push(d)
        }
        
      }
      
    });

  store.groups = data
};

const nextPage = (event) => { 

	let myhosp_year = myhosp.value.myhosp_year;
	const clicked = event.target.value;
	
	console.log("clicked " + clicked);

	if ( clicked == 'peergroup' ) {
		let data = []; 
		console.log(myHospital);
		console.log("Peer Group");
		data.push({ 'peergroup': "peergroup", 
			'group_year': myhosp_year, 
			'group_name': 'My Peer Group',
			'group_geography':"national",
			"group_geography_state":0,
			"group_geography_region": 0,
			"group_geography_national":0,
			'group_netpatrev':getRevcatInt(),
			'group_ruralclinic':getHasrhcInt(),
			'group_longtermcare':getHassnf(),
			'group_govtowned':getGovt(),
			'group_system':0,
			'group_cahid':"",
			'group_hidden': false,
			'index': 1
		})
		
		store.groups = data
		
	} else if (clicked == "state") {
		let data = []; 
		console.log("state");
		data.push({ 'state': "state",
		 'group_year': myhosp_year,
		 'group_name': 'My State',
		 'group_geography':"state",
		"group_geography_state":myHospital.cahstate,
		"group_geography_region": 0,
		"group_geography_national":0,
		"group_geography_national":0,
		'group_netpatrev':0,
		'group_ruralclinic':0,
		'group_longtermcare':0,
		'group_govtowned':0,
		'group_system':0,
		'group_cahid':"",
		'group_hidden': false,
		'index': 1
		}) 

		store.groups = data
		
	} else if (clicked == 'custom') {
		handleGroupData();
    	
	} else {
		console.log('stuck')
	}
	store.loadPage('visualization');

	
};

// setting form-like getters for use in vis
    const getRevcatInt = () => { 
        var int = 0;
        switch (myHospital.revcat) {
                case 'Under 10m':
                    int = 1;
                    break;
                case '10-20m':
                    int = 2;
                    break;
                case 'Over 20m':
                    int = 3;
                    break;
                default:
                    int = 0;
                    break;
            }

        return int;
    };

    const getHasrhcInt = () => { 
    
        var int = 0;
        switch (myHospital.hasrhc) {
            case 'No RHC':
                int = 2;
                break;
            case 'Has RHC':
                int = 1;
                break;
            default:
                int = 0;
                break;
        }

        return int;
    }


    const getHassnf = () => { 
        var int = 0;
        switch (myHospital.hassnf) {
            case 'Has LTC':
                int = 1;
                break;
            case 'No LTC':
                int = 2;
                break;
            default:
                int = 0;
                break;
        }

        return int;
    }


    const getGovt = () => { 
        var int = 0;
        switch (myHospital.govt) {
            case 'Govt':
                int = 1;
                break;
            case 'Nongovt':
                int = 2;
                break;
            default:
                int = 0;
                break;
        }

        return int;
    }


</script>